import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as RetirementIcon } from "uikit/Icons/retirement-goal.svg"
import { formatCurrency } from "uikit/utilities"

const RetirementAge = ({
  early_retirement_years,
  max_retirement_age,
  first_name,
  showName
}) => {
  return (
    <div>
      <p
        className="GoalCard_SecondText"
        style={{
          fontSize: "1.9em",
          marginBottom: "0",
          color: "#8ed72a"
        }}
      >
        {early_retirement_years > 0
          ? `${max_retirement_age - early_retirement_years}-`
          : ""}
        {max_retirement_age}
      </p>
      <div className="greyed-text">
        <p style={{ marginBottom: "0" }}>{`${
          showName ? `${first_name}'s` : ""
        } age`}</p>
      </div>
    </div>
  )
}

const Retirement = ({
  id,
  people,
  client,
  spouse,
  amount,
  baseUrl,
  type,
  net_income
}) => {
  const { client: clientDetails, spouse: spouseDetails } = people
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <RetirementIcon />
              </Grid.Column>
              <Grid.Column>
                <span className="GenericCard__LinkTitle">Retirement</span>
                <p
                  className="GoalCard_Price"
                  style={{
                    fontSize: "2.4em",
                    marginBottom: "0",
                    color: "#8ed72a",
                    paddingTop: "16px"
                  }}
                >
                  {formatCurrency(amount)}
                </p>
                {net_income > 0 ? (
                  <p className="greyed-text">
                    in general spending
                    <br />
                    per year
                  </p>
                ) : null}
              </Grid.Column>
              <Grid.Column className="GoalCard_Year_Div" verticalAlign="middle">
                {client && (
                  <RetirementAge
                    {...client}
                    {...clientDetails}
                    showName={!!spouseDetails}
                  />
                )}
                {spouse && spouseDetails && (
                  <Grid.Row columns={1}>
                    <RetirementAge
                      {...spouse}
                      {...spouseDetails}
                      showName={!!spouseDetails}
                    />
                  </Grid.Row>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}

export default Retirement
